// CFO IA - Cockpit Finances TEF & facturation AMO
import { useState } from "react";
import { Euro, BarChart3, Receipt, TrendingUp, MessageSquare, LayoutDashboard } from "lucide-react";
import { Button } from "../../components/ui/button";
import CxOChatPanel from "./CxOChatPanel";
import DashboardFinance from "../hubs/DashboardFinance";

const API = process.env.REACT_APP_BACKEND_URL;

export default function CFODashboard() {
  const [activeTab, setActiveTab] = useState("dashboard");

  const tabs = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { id: "chat", label: "Mode Conversationnel", icon: MessageSquare },
  ];

  return (
    <div className="space-y-4" data-testid="cfo-dashboard">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-3" style={{ color: "var(--oh-text)" }}>
            <Euro className="w-7 h-7 text-yellow-500" />
            CFO IA
          </h1>
          <p className="text-sm mt-1" style={{ color: "var(--oh-text-muted)" }}>
            Finances TEF & facturation AMO
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 p-1 rounded-lg" style={{ background: "var(--oh-bg-surface)" }}>
        {tabs.map(tab => (
          <Button
            key={tab.id}
            variant="ghost"
            size="sm"
            onClick={() => setActiveTab(tab.id)}
            data-testid={`cfo-tab-${tab.id}`}
            className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all ${
              activeTab === tab.id
                ? "shadow-sm"
                : ""
            }`}
            style={{
              background: activeTab === tab.id ? "var(--oh-bg-elevated)" : "transparent",
              color: activeTab === tab.id ? "var(--oh-text)" : "var(--oh-text-muted)",
              border: activeTab === tab.id ? "1px solid var(--oh-border)" : "1px solid transparent",
            }}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </Button>
        ))}
      </div>

      {/* Content */}
      {activeTab === "dashboard" && <DashboardFinance />}
      {activeTab === "chat" && (
        <CxOChatPanel
          cxoType="cfo"
          agentName="CFO IA"
          agentColor="text-yellow-500"
          agentIcon={Euro}
        />
      )}
    </div>
  );
}
